/* SessionStatusIndicator.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIey7F%7Bmin-width%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
import React from 'react';
import { useIntl } from 'react-intl';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import Spinner from '@atlaskit/spinner/spinner';
import { messages } from './messages';
import { SessionStatusBadge } from './SessionStatusBadge';
import { SessionStatusIcon } from './SessionStatusIcon';
import { SessionUnreadIndicator } from './SessionUnreadIndicator';
const styles = {
  indicator: "_4ouGXIey7F _3YEZNOdnbC"
};
export type SessionStatusIndicatorProps = {
  /** Transient activity takes priority over attention and unread state. */
  isInProgress?: boolean;
  requiresInput?: boolean;
  /** Controls whether needs input uses the full badge or its compact icon treatment. */
  requiresInputAppearance?: 'badge' | 'icon';
  isUnread?: boolean;
  testId?: string;
};

/** Shows one indicator, in priority order: in progress, needs input, then unread. */
export const SessionStatusIndicator = ({
  isInProgress,
  requiresInput,
  requiresInputAppearance = 'badge',
  isUnread,
  testId
}: SessionStatusIndicatorProps): React.JSX.Element | null => {
  const {
    formatMessage
  } = useIntl();
  const indicator = isInProgress ? <Spinner size="small" label={formatMessage(messages.inProgress)} /> : requiresInput ? requiresInputAppearance === 'icon' ? <SessionStatusIcon status="needs-input" iconSize={16} color={"var(--ds-icon-accent-blue, #357DE8)"} label={formatMessage(messages.needsInput)} testId="session-status-icon" /> : <SessionStatusBadge status="needs-input" iconSize={16} /> : isUnread ? <SessionUnreadIndicator /> : null;
  return indicator ? <Inline as="span" alignBlock="center" alignInline="center" xcss={styles.indicator} testId={testId}>
			{indicator}
		</Inline> : null;
};